"use client";

import { GlareCard } from "@/components/ui/Card/GlareCard";
import { ContactModal } from "@/components/ui/Modal/ContactModal";
import { Highlight, HightLightText } from "@/components/ui/Text/HightLightText";
import { INFO } from "@/contants";
import { motion } from "framer-motion";
import Image from "next/image";

export default function About() {
  return (
    <div className="bg-white dark:bg-[#171420] mt-4 py-10 mb-20 relative">
      <div className="container color-home after:top-0">
        <div className="flex flex-wrap p-6 lg:gap-28">
          <motion.div
            initial={{ opacity: 0, y: 200 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2, ease: "easeInOut" }}
            viewport={{ once: true }}
            className="w-full lg:w-2/5 flex justify-center order-2 lg:order-1"
          >
            <GlareCard className="flex flex-col items-center justify-center">
              <Image
                alt="Avatar Về Mình"
                sizes="100vw"
                width={0}
                height={0}
                className="h-full w-full absolute inset-0 object-cover"
                src="/images/avatar/hodoan.JPG"
              />
            </GlareCard>
          </motion.div>
          <div className="flex flex-col w-full lg:w-[calc(60%-128px)] order-1 lg:order-2 mb-10 lg:mb-0">
            <motion.span
              initial={{ opacity: 0, x: 100 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7, delay: 0.3, ease: "easeInOut" }}
              viewport={{ once: true }}
              className="text-xl text-main-green font-medium"
            >
              Giới thiệu
            </motion.span>
            <motion.h1
              initial={{ opacity: 0, x: 100 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7, delay: 0.4, ease: "easeInOut" }}
              viewport={{ once: true }}
              className="text-primary dark:text-[#45c3dc] text-4xl lg:text-5xl font-bold mb-16 mt-4 uppercase"
            >
              Về Mình
            </motion.h1>
            <motion.div
              initial={{ opacity: 0, x: 100 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: 0.5, ease: "easeInOut" }}
              viewport={{ once: true }}
              className="text-main-dark dark:text-main-gray text-base font-medium max-w-[550px] text-justify leading-5 lg:leading-7"
            >
              <HightLightText>
                <motion.h4
                  initial={{
                    opacity: 0,
                    y: 20,
                  }}
                  whileInView={{
                    opacity: 1,
                    y: [20, -5, 0],
                  }}
                  transition={{
                    duration: 0.5,
                    ease: [0.4, 0.0, 0.2, 1],
                  }}
                  viewport={{ once: true }}
                >
                  Xin chào mọi người, mình là Hồ Văn Đoan. Hiện tại, mình đang
                  làm việc trong lĩnh vực{" "}
                  <Highlight className="text-black dark:text-white">
                    lập trình và thiết kế website
                  </Highlight>{" "}
                  tại Đà Nẵng. Mình đang làm việc toàn thời gian với vai trò{" "}
                  <Highlight className="text-black dark:text-white">
                    Full-stack Developer
                  </Highlight>{" "}
                  tại Kozocom và nhận thêm các dự án freelance khi có thời gian
                  rảnh. Với 3 năm kinh nghiệm trong nghề, dù còn một số điểm cần
                  cải thiện, mình vẫn tự tin có thể{" "}
                  <Highlight className="text-black dark:text-white">
                    đáp ứng tốt các yêu cầu công việc.
                  </Highlight>
                </motion.h4>
              </HightLightText>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: 0.6, ease: "easeInOut" }}
              viewport={{ once: true }}
              className="border border-primary dark:border-[#45c3dc] mt-10 max-w-[550px] rounded-md grid grid-cols-1 lg:grid-cols-2 p-4"
            >
              {INFO.map((field) => (
                <div
                  key={field.label}
                  className="col-span-1 text-[14px] py-1.5"
                >
                  <span className="font-bold pr-1">{field.label}: </span>
                  <span>{field.value}</span>
                </div>
              ))}
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.8, ease: "easeOut" }}
              viewport={{ once: true }}
            >
              <ContactModal />
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
}
